"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageIdFromLocale = exports.determineLocale = void 0;
const locale_1 = require("../../common/js/helper/locale");
const Languages_1 = require("../constants/Languages");
const LocalStorageKeys_1 = __importDefault(require("../enums/LocalStorageKeys"));
const Route_1 = __importDefault(require("../stores/Route"));
const determineLocale = () => {
    const map = __APP__.LOCALE_MAP ?? {};
    const locale = [
        Route_1.default.localeOfUrl,
        localStorage.getItem(LocalStorageKeys_1.default.language),
        navigator.language,
        Languages_1.DEFAULT_LANGUAGE,
    ]
        .map((code) => (0, locale_1.getLanguageFromLocale)(code))
        .find((code) => !!code && !!map[code]);
    return locale ?? Languages_1.DEFAULT_LANGUAGE;
};
exports.determineLocale = determineLocale;
const getLanguageIdFromLocale = (locale) => {
    const code = (0, locale_1.getLanguageFromLocale)(locale);
    if (!code) {
        return null;
    }
    return (__APP__.LOCALE_MAP ?? {})[code] ?? null;
};
exports.getLanguageIdFromLocale = getLanguageIdFromLocale;
